import { getAntiForgeryToken } from "../utils/Fetch";

export function containsUnavailableFilters(filterIds: string[], cb: (result: boolean) => void) {
	let $ = (window as any).$;
	
	$.ajax({
		url: "/Filters/ContainsUnavailableFilter/",
		data: {
			__RequestVerificationToken: getAntiForgeryToken(),
			filterIds: filterIds
		},
		type: 'POST',
		success: function (result: string) {
			cb(result.toLowerCase() == "true");
		}
	});
}